import "./App.css";

function App() {
  return (
    <div className="App">
      <h1>Metronome & Tuner – Support</h1>
      <p>
        Welcome! Use the form below to report bugs, request features, or get in
        touch with support.
      </p>
      <form
        action="https://formsubmit.co/4932291ef5d3eafa641d13c1a82b6825"
        method="POST"
        style={{ maxWidth: 500, margin: "2rem auto", textAlign: "left" }}
      >
        <input type="hidden" name="_captcha" value="false" />
        <label>
          Message:
          <textarea name="message" rows="5" required style={{ width: "100%" }} />
        </label>
        <br />
        <button type="submit" style={{ marginTop: "1rem" }}>
          Send
        </button>
      </form>
      <hr style={{ margin: "3rem 0" }} />
      <p>
        <strong>App Version:</strong> 1.0<br />
        <strong>Developer:</strong> Joseph Satzl<br />
        <strong>Email:</strong> josephsatzl@gmail.com
      </p>
    </div>
  );
}

export default App;
